if (document.getElementById('ee-tracking-page')) {

    // --- helpery bezpieczeństwa ---

    // Escapuje wartości wstawiane do innerHTML (ochrona przed XSS).
    function esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }

    // Dopuszcza tylko http(s) w linku trackingu (blokuje np. javascript:).
    function safeUrl(u) {
        try {
            const p = new URL(u);
            return (p.protocol === 'https:' || p.protocol === 'http:') ? p.href : '#';
        } catch {
            return '#';
        }
    }

    document
        .getElementById('orderTrackingForm')
        .addEventListener('submit', async function (e) {

            e.preventDefault();

            const orderNumber =
                document.getElementById('orderNumber').value.trim();

            const email =
                document.getElementById('orderEmail').value.trim();

            const resultBox =
                document.getElementById('tracking-result');

            resultBox.style.display = 'block';

            resultBox.innerHTML = `
                <div class="ee-result">
                    <div class="ee-result-title">
                        Wir suchen Ihre Sendung...
                    </div>
                </div>
            `;

            // Blokada przycisku na czas zapytania (brak podwójnych kliknięć)
            const submitBtn = e.currentTarget.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn ? submitBtn.textContent : '';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Suche läuft…';
            }

            try {

                const response = await fetch(
                        'https://euroelectronics-tracker.patryk-sprus.workers.dev/track',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            orderNumber,
                            email,
                            store: "DE"
                        })
                    }
                );

const data = await response.json();

// Za dużo prób (rate limit) — osobny komunikat
if (response.status === 429 || data.status === 'RATE_LIMITED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Zu viele Versuche
            </div>

            <div class="ee-error-message">
                Sie haben zu viele Suchvorgänge hintereinander durchgeführt. Bitte warten Sie eine Minute und versuchen Sie es erneut.
            </div>

        </div>
    `;

    return;
}

if (data.status === 'CANCELLED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Die Bestellung wurde storniert
            </div>

            <div class="ee-error-message">
                Diese Bestellung wurde storniert und wird nicht weiter bearbeitet.
            </div>

        </div>
    `;

    return;
}

if (!data.success) {

if (data.status === 'NOT_SHIPPED') {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-pending">

                <div class="ee-result-title">
                    Wir bereiten Ihre Bestellung vor
                </div>

<div class="ee-info-message">


 <br>

    Ihre Bestellung ist eingegangen und wird bearbeitet.

    <br><br>

    Es wurde noch keine Sendungsnummer zugewiesen. Sobald die Sendung versendet wurde, sind die Sendungsverfolgungsinformationen auf dieser Seite und per E-Mail verfügbar.

    <br><br>

    Wenn Sie weitere Fragen zu Ihrer Bestellung haben, wenden Sie sich bitte an unseren Kundenservice.

    <br>

                    <a href="https://dieuroelectronics.com/pages/kontakt" class="ee-contact-link">
                        Kontaktieren Sie uns
                    </a>

                </div>

            </div>
        `;

    } else {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-error">

                <div class="ee-result-title">
                    Bestellung nicht gefunden
                </div>

                <div class="ee-error-message">
                    Wir konnten keine Bestellung finden, die zur angegebenen Bestellnummer und E-Mail-Adresse passt. Bitte überprüfen Sie, ob die Angaben korrekt eingegeben wurden, und versuchen Sie es erneut.
                    <br><br>

                    Wenn Sie Hilfe benötigen, wenden Sie sich bitte an unseren Kundenservice.
                    <br>

                    <a href="https://dieuroelectronics.com/pages/kontakt" class="ee-contact-link">
                        Zum Kontaktformular
                    </a>

                </div>

            </div>
        `;

    }

    return;
}
const productsHtml =
  (data.products || [])
    .map(product => `
 <div class="ee-product">

    <div class="ee-product-content">

        <div class="ee-product-title">
            ${esc(product.title)}
        </div>

    </div>

    <div class="ee-product-qty">
        ${esc(product.quantity)}x
    </div>

</div>
    `)
    .join('');

                resultBox.innerHTML = `
                    <div class="ee-result">

                        <div class="ee-result-title">
                            Sendung gefunden
                        </div>
<div class="ee-result-description">
                            Nachfolgend finden Sie Informationen zu Ihrer Sendung. Klicken Sie auf die Schaltfläche unten, um direkt zur Sendungsverfolgung beim Versanddienstleister zu gelangen.
                       </div>

                       

                        <div class="ee-result-grid">

                            <div>
                                <div class="ee-result-label">
                                    Bestellnummer
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.orderNumber || orderNumber)}
                                </div>
                            </div>

                            <div>
                                <div class="ee-result-label">
                                    Sendungsnummer
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.trackingNumber)}
                                </div>
                            </div>

                        </div>

                        <a
                            href="${safeUrl(data.trackingUrl)}"
                            target="_blank"
                            rel="noopener"
                            class="ee-track-btn"
                        >
                            Sendung verfolgen
                        </a>

                    </div>

                    <div class="ee-products-section">

  <div class="ee-products-title">
       Bestellte Produkte (${data.products?.length || 0})
  </div>

  ${productsHtml}

</div>
                `;

                resultBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });

            } catch (err) {

                console.error(err);

                resultBox.innerHTML = `
                    <div class="ee-result ee-result-error">

                        <div class="ee-result-title">
                            Ein Fehler ist aufgetreten
                        </div>

                        <p>
                            Es konnte keine Verbindung zum Sendungsverfolgungssystem hergestellt werden. Bitte versuchen Sie es in Kürze erneut.
                        </p>

                    </div>
                `;

            } finally {

                // Odblokowanie przycisku niezależnie od wyniku
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }

            }

        });

}
